<template>
  <v-container fluid class="pa-0">
    <v-card>
      <v-card-title>{{ $t("event.about") }}</v-card-title>
      <v-card-text>
        <v-form v-model="isFormValid">
          <v-row>
            <v-col class="pb-0">{{ $t("event_about.html_content") }}</v-col>
          </v-row>
          <v-row>
            <v-col>
              <froala
                v-if="showEditor"
                :config="froalaConfig"
                v-model="eventAbout.html_content"
              ></froala>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="primary"
                @click="saveEventAbout"
                :disabled="!isFormValid"
              >
                {{ $t("save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import { useGet } from "feathers-vuex";
import froalaConfig from "../../froala-config";

export default {
  name: "EventAbout",
  setup(props, { root }) {
    const { Event } = root.$FeathersVuex.api;
    const showEditor = ref(false);

    const eventId = computed(() => root.$route.params.eventId);
    const { item: event } = useGet({ model: Event, id: eventId });

    const eventAbout = computed(() => {
      return event.value ? event.value.f_about : {
        html_content: '',
      };
    });

    const isFormValid = ref(false);

    const saveEventAbout = async function() {
      eventAbout.value.save().then(() => {
        root.$store.dispatch(
          "showSnackBar",
          root.$t("event_about.save_successful")
        );
      }, root.$handleFeatherError.bind(root));
    };

    return {
      eventAbout,
      showEditor,
      isFormValid,
      saveEventAbout,
      froalaConfig,
    };
  },
  mounted() {
    setTimeout(() => {
      this.showEditor = true;
    }, 100);
  }
};
</script>
